export default __webpack_public_path__ + "static/media/celebracion.6afb4915.svg";